import React from 'react';
import { Grid } from '@mui/material';

import { Company } from '../../../models/company.model';
import { SupplierWithId } from '../../../models/supplier.model';
import SupplierDetailsCard from '../../../common/supplier-details-card/SupplierDetailsCard';
import BankDetailsCard from '../../../common/bank-details-card/BankDetailsCard';

interface DetailsTabsProps {
  company: Company;
  supplier: SupplierWithId;
  key: string;
}

const DetailsTabs: React.FC<DetailsTabsProps> = ({ supplier }) => {
  const bankDetails = supplier?.supplier_bank_details;
  return (
    <>
      <Grid component='div' container wrap='wrap' style={{ rowGap: '16px', paddingBottom: '16px' }}>
        <Grid component='div' size={{ xs: 12 }}>
          <SupplierDetailsCard supplier={supplier} />
        </Grid>
        <Grid component='div' size={{ xs: 12 }}>
          {bankDetails &&
            bankDetails.length > 0 &&
            bankDetails.map((bank) => (
              <Grid component='div' key={bank?.id}>
                <BankDetailsCard
                  bank={bank}
                  supplierId={supplier?.id}
                  isSupplierBankDetails={true}
                />
              </Grid>
            ))}
          {bankDetails?.length === 0 && (
            <Grid component='div'>
              <BankDetailsCard isSupplierBankDetails={true} supplierId={supplier?.id} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default DetailsTabs;
